/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { BaseModalProps, Modal } from '@blend/shared-react';
import { colors, mixins } from '@blend/consumer-components';

export namespace OverlayModal {
  export interface Props extends Omit<BaseModalProps, 'handleClose'> {
    header: string;
    subHeader?: string;
    overlayBackgroundColor?: string;
  }
}

const styles = StyleSheet.create({
  contentWrapper: {
    ...mixins.margin(40, 40, 40, 40),
  },
  headerText: {
    fontSize: 24,
    textAlign: 'center',
    fontWeight: 'bold',
    marginBottom: 40,
  },
  subHeaderText: {
    fontSize: 16,
    lineHeight: '22px',
    marginBottom: 24,
  },
});

export const OverlayModal: React.FC<OverlayModal.Props> = ({
  header,
  subHeader,
  isOpen,
  contentLabel,
  children,
  overlayBackgroundColor = colors.catalyst,
}) => {
  const overlayStyleConfig = {
    backgroundColor: overlayBackgroundColor,
  };
  return (
    <Modal
      data-it="OverlayModal"
      overlayStyleConfig={overlayStyleConfig}
      isOpen={isOpen}
      contentLabel={contentLabel}
      handleClose={() => {}}
    >
      <div className={css(styles.contentWrapper)}>
        <div className={css(styles.headerText)} data-dd-privacy="allow">
          {header}
        </div>
        {subHeader && (
          <div data-it="OverlayModal-SubHeader" className={css(styles.subHeaderText)}>
            {subHeader}
          </div>
        )}
        {children}
      </div>
    </Modal>
  );
};
